import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPayloadCreator } from "util/api";
import { useSelector } from "react-redux";

const apiCall = createAsyncThunk(
  "enumeratedDataValues/loader",
  apiPayloadCreator("/enumerated-data-values", "get")
);

export const enumeratedDataValuesSlice = createSlice({
  name: "enueratedDataValues",
  initialState: { loaded: null, data: {} },
  reducers: {},
  extraReducers: {
    [apiCall.pending]: (state, action) => {
      state.loading = true;
    },
    [apiCall.fulfilled]: (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.data = action.payload;
    },
    [apiCall.rejected]: (state, action) => {
      state.loading = false;
      state.loaded = false;
      state.error = action.payload;
    },
  },
});

enumeratedDataValuesSlice.selector = (store) => store.enumeratedDataValues;

enumeratedDataValuesSlice.asyncActions = {
  load: () => (dispatch) => dispatch(apiCall({})),
};

/* Convenience hook to return a list and lookup table for a specific
  set of enumerated data values. */

export function useEnumeratedDataTable(table) {
  const enumeratedDataValues = useSelector(enumeratedDataValuesSlice.selector);
  const list = enumeratedDataValues.data[table];
  const lookup = Object.fromEntries(list.map((o) => [o.id, o]));

  return { list, lookup };
}

export default enumeratedDataValuesSlice.reducer;
